import { combineReducers } from "redux";

// Common
import AlertReducer from "./Alert/reducer";
// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";
import authReducer from "./authSlice";

// ------------------------- WEB -------------------------
// Menu
import ShopMenuReducer from "./Web/shopMenu/reducer";
import DetailShopMenuSliceReducer from "./Web/detailShopMenu/reducer";
import draftOrdersReducer from "./draftOrders/reducer";
import CartReducer from "./Web/cart/cartSlice";
import OrderDetailReducer from "./Order/detail/reducer";
import draftOrderDetailsReducer from "./draftOrderDetails/reducer";
import MenuListReducer from "./Menu/reducer";
import MenuOptionsReducer from "./MenuOptions/reducer";
import NotificationsReducer from "./Notification/reducer";
import UnclaimedOrdersReducer from "./Order/unclaimed/reducer";
import TablesReducer from "./Tables/reducer";
import ZonesReducer from "./Zones/reducer";
import ShopInfoReducer from "./ShopInfo/reducer";
import ShopWifiReducer from "./ShopWifi/reducer";
import TableQrsReducer from "./TableQrs/reducer";

const appReducer = combineReducers({
    auth: authReducer,
    Alert: AlertReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    ShopMenu: ShopMenuReducer,
    DetailShopMenu: DetailShopMenuSliceReducer,
    draftOrders: draftOrdersReducer,
    draftOrderDetails: draftOrderDetailsReducer,
    Cart: CartReducer,
    OrderDetail: OrderDetailReducer,
    MenuList: MenuListReducer,
    MenuOptions: MenuOptionsReducer,
    notifications: NotificationsReducer,
    unclaimedOrders: UnclaimedOrdersReducer,
    Tables: TablesReducer,
    Zones: ZonesReducer,
    ShopInfo: ShopInfoReducer,
    ShopWifi: ShopWifiReducer,
    TableQrs: TableQrsReducer,
});

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: any) => {
    if (action.type === "login/logoutUserSuccess") {
        state = undefined;
    }

    return appReducer(state, action);
};

export default rootReducer;
